export function parseAllergenSolutionList(value) {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value
      .map((entry) => {
        if (entry == null) return "";
        if (typeof entry === "object") return String(entry.solution ?? "").trim();
        return String(entry).trim();
      })
      .filter(Boolean);
  }
  return String(value)
    .split(/[,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

/** Solutions the customer may choose, from item API fields (not HasCustomerChoice). */
export function getProductAllergenChoices(item) {
  if (!item) return [];
  const raw = item.originalItem || item;
  const fromChoices = parseAllergenSolutionList(
    item.allergenChoices ?? raw.allergenChoices
  );
  if (fromChoices.length) return [...new Set(fromChoices)];
  return [
    ...new Set(
      parseAllergenSolutionList(
        item.allergenSolutions ??
          raw.allergenSolutions ??
          item.AllergenSolutions ??
          raw.AllergenSolutions
      )
    ),
  ];
}

export function joinSelectedAllergenSolutions(item) {
  const selected = item?.selectedAllergenSolutions;
  if (Array.isArray(selected)) {
    return selected.map((s) => String(s).trim()).filter(Boolean).join(", ");
  }
  if (typeof selected === "string") {
    return selected.trim();
  }
  return "";
}
